import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Pan = ({ svgSize = ICON_SIZES.MD, className = '' }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 3.73306C20.4182 3.73306 23.9999 7.3149 24 11.7331C24 16.1513 20.4183 19.7331 16 19.7331C11.5817 19.7331 8 16.1513 8 11.7331C8.00014 7.3149 11.5818 3.73306 16 3.73306Z"
          fill={theme.icon.fill}
        />
        <path
          d="M18.0004 2.66666C18.3683 2.66692 18.6674 2.96562 18.6674 3.33365C18.6673 3.38411 18.6595 3.43287 18.6488 3.48013C22.1395 4.59967 24.6672 7.87072 24.6674 11.7331C24.6674 15.7839 21.887 19.1845 18.1312 20.1344C18.4662 20.5802 18.6673 21.1327 18.6674 21.7331V27.0661C18.6674 28.5387 17.4729 29.7328 16.0004 29.7331C14.5276 29.7331 13.3334 28.5388 13.3334 27.0661V21.7331C13.3334 21.1329 13.5328 20.5801 13.8676 20.1344C10.1123 19.1841 7.33337 15.7836 7.33337 11.7331C7.33349 7.87105 9.85977 4.59994 13.35 3.48013C13.3393 3.43294 13.3334 3.38404 13.3334 3.33365C13.3334 2.96546 13.6322 2.66666 14.0004 2.66666H18.0004ZM16.0004 20.4001C15.2641 20.4001 14.6675 20.9968 14.6674 21.7331V27.0661C14.6674 27.8025 15.264 28.4001 16.0004 28.4001C16.7365 28.3998 17.3334 27.8023 17.3334 27.0661V21.7331C17.3332 20.997 16.7364 20.4003 16.0004 20.4001ZM16.0004 4.40005C11.9504 4.40005 8.6675 7.68309 8.66736 11.7331C8.66736 15.7832 11.9503 19.0661 16.0004 19.0661C20.0502 19.0658 23.3334 15.783 23.3334 11.7331C23.3332 7.68326 20.0501 4.40032 16.0004 4.40005ZM16.0004 6.06607C19.1297 6.06633 21.6672 8.60373 21.6674 11.7331C21.6674 14.8625 19.1298 17.3998 16.0004 17.4001C12.8708 17.4001 10.3334 14.8627 10.3334 11.7331C10.3335 8.60357 12.8708 6.06607 16.0004 6.06607ZM16.0004 7.40005C13.6072 7.40005 11.6675 9.33995 11.6674 11.7331C11.6674 14.1263 13.6071 16.0661 16.0004 16.0661C18.3934 16.0658 20.3334 14.1261 20.3334 11.7331C20.3332 9.34011 18.3933 7.40032 16.0004 7.40005Z"
          fillRule="evenodd"
          fill={theme.icon.stroke}
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 7C35.732 7 42 13.268 42 21C42 28.732 35.732 35 28 35C20.268 35 14 28.732 14 21C14 13.268 20.268 7 28 7Z"
        fill={theme.icon.fill}
      />
      <path
        d="M31.5 4.95801C31.9831 4.95801 32.3748 5.34991 32.375 5.83301C32.375 6.18873 32.1622 6.49405 31.8574 6.63086C38.2025 8.32994 42.875 14.119 42.875 21C42.875 27.7604 38.3647 33.4661 32.1895 35.2754L30.7754 39.2734C30.6935 39.5052 30.671 39.7545 30.7109 39.9971L31.916 47.3115C32.2378 49.2651 30.7309 51.0418 28.751 51.042H27.249C25.2691 51.0418 23.7622 49.2651 24.084 47.3115L25.2891 39.9971C25.329 39.7545 25.3065 39.5052 25.2246 39.2734L23.8096 35.2754C17.6347 33.4658 13.125 27.7601 13.125 21C13.125 14.1193 17.797 8.33025 24.1416 6.63086C23.8373 6.49387 23.625 6.18842 23.625 5.83301C23.6252 5.34991 24.0169 4.95801 24.5 4.95801H31.5ZM30.1768 35.7148C29.4662 35.8191 28.7395 35.875 28 35.875C27.2598 35.875 26.5325 35.8192 25.8213 35.7148L26.875 38.6904C27.0553 39.2004 27.1036 39.7485 27.0156 40.2822L25.8105 47.5967C25.6645 48.4845 26.3492 49.2918 27.249 49.292H28.751C29.6508 49.2918 30.3355 48.4845 30.1895 47.5967L28.9844 40.2822C28.8964 39.7485 28.9447 39.2004 29.125 38.6904L30.1768 35.7148ZM28.0576 44.625C28.5409 44.625 28.9326 45.0168 28.9326 45.5L28.9336 47.25C28.9336 47.7331 28.5416 48.1247 28.0586 48.125C27.5753 48.125 27.1836 47.7332 27.1836 47.25L27.1826 45.5C27.1826 45.0169 27.5746 44.6253 28.0576 44.625ZM28 7.875C20.7513 7.875 14.875 13.7513 14.875 21C14.875 27.3221 19.345 32.5996 25.2969 33.8457C25.4634 33.8723 25.6542 33.9043 25.8604 33.9336C26.5575 34.0326 27.3817 34.125 28 34.125C28.6183 34.125 29.4425 34.0326 30.1396 33.9336C30.3454 33.9044 30.5358 33.8723 30.7021 33.8457C36.6545 32.5999 41.125 27.3224 41.125 21C41.125 13.7513 35.2487 7.875 28 7.875ZM28 10.791C33.6376 10.7913 38.2088 15.3624 38.209 21C38.2088 26.6376 33.6376 31.2077 28 31.208C22.3624 31.2078 17.7922 26.6376 17.792 21C17.7922 15.3623 22.3623 10.7912 28 10.791ZM28 12.541C23.3288 12.5412 19.5422 16.3288 19.542 21C19.5422 25.6712 23.3288 29.4578 28 29.458C32.6711 29.4577 36.4588 25.6711 36.459 21C36.4588 16.3289 32.6711 12.5413 28 12.541Z"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

Pan.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Pan;
